import { defineStore } from 'pinia';

export const useEventStore = defineStore('eventBus', {
  state: () => ({
    eventData: null, // emitted data
    eventName: null, // event name
  }),
  actions: {
    emit(eventName, data = null) {
      this.eventName = eventName;
      this.eventData = data; // Triggers $subscribe
    },
    // on(eventName, callback) {
    //   const unsubscribe = this.$subscribe((mutation, state) => {
    //     if (state.eventName === eventName) {
    //       callback(state.eventData);
    //     }
    //   });
    //   return unsubscribe; // Return cleanup function
    // }
  },
});